// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Lj","edit_box_title":"Mj","subscription":"Nj","byb":"Oj","recommended_for_you_title":"Pj","explore":"Qj","recommended":"Rj","go_back":"Sj","wrapper":"Tj","product_img":"Uj","info":"Vj","remove_btn":"Wj"};
    if(module.hot) {
      // 1714654863400
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  